import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface RegistrationDetailsProps {
  className?: string;
}

const RegistrationDetails = ({ className = '' }: RegistrationDetailsProps) => {
  const registrationData = [
    {
      title: 'DTI Business Name Registration',
      subtitle: 'Department of Trade and Industry',
      image: '/business name registration.jpg',
      alt: 'TravelEase.Co Travel Service - DTI Certificate of Business Name Registration',
      details: [
        {
          label: 'Registered Business Name',
          value: 'TRAVELEASE CO TRAVEL SERVICE (CITY/MUNICIPALITY)',
        },
        {
          label: 'Proprietor',
          value: 'Abegail Princess Rosales Gutierrez',
        },
        {
          label: 'Business Registration Number',
          value: '7566276',
        },
        {
          label: 'Location',
          value: 'Bacoor, Cavite Philippines',
        },
        {
          label: 'Registration Date',
          value: 'November 6, 2025',
        },
        {
          label: 'Valid Until',
          value: 'November 6, 2030',
        },
        {
          label: 'Registered Under',
          value: 'Act 3883, Act 4147, and Republic Act No. 863',
        },
      ],
      description:
        'Our DTI Certificate confirms that TravelEase.Co Travel Service is an officially registered business name in the Philippines. This registration is required by law for all sole proprietorships and ensures that our business operates legally under Philippine trade regulations.',
    },
    {
      title: 'BIR Certificate of Registration',
      subtitle: 'Bureau of Internal Revenue - Form 2303',
      image: '/tax paying certificate registration.jpg',
      alt: 'TravelEase.Co - BIR Certificate of Registration Form 2303',
      details: [
        {
          label: 'Taxpayer Name',
          value: 'Gutierrez, Abegail Princess Rosales',
        },
        {
          label: 'Tax Identification Number (TIN)',
          value: '287-166-158-0000',
        },
        {
          label: 'Taxpayer Type',
          value: 'Single Proprietorship Only (Resident Citizen)',
        },
        {
          label: 'Trade Name',
          value: 'TRAVELEASE.CO TRAVEL SERVICE',
        },
        {
          label: 'Business Category (PSIC)',
          value: '79110 - Travel Agency Activities',
        },
        {
          label: 'Line of Business',
          value: 'Travel Services (Primary)',
        },
        {
          label: 'Registered Address',
          value: 'Bacoor, Cavite Philippines',
        },
        {
          label: 'Registration Office',
          value: 'Revenue Region No. 09A - Cabamiro (Cavite-Batangas-Mindoro-Romblon)',
        },
        {
          label: 'OCN Number',
          value: '54BRC20250000014683',
        },
        {
          label: 'Date Generated',
          value: 'November 13, 2025',
        },
      ],
      description:
        'Our BIR Certificate of Registration (Form 2303) confirms that TravelEase.Co is registered with the Bureau of Internal Revenue and authorized to conduct travel service operations in the Philippines. This registration ensures we comply with all tax obligations and are authorized to issue official receipts to our clients.',
    },
    {
      title: 'Official Receipt/Invoice Authorization',
      subtitle: 'BIR-Compliant Receipt Issuance',
      image: '/recipt issue notice.jpg',
      alt: 'TravelEase.Co - BIR Official Receipt/Invoice Compliance Notice',
      details: [
        {
          label: 'Business Name',
          value: 'TravelEase.Co',
        },
        {
          label: 'Registered Name',
          value: 'TravelEase.Co Travel Services',
        },
        {
          label: 'TIN and Branch Code',
          value: '287-166-158-0000',
        },
        {
          label: 'Authorization',
          value: 'Required to issue Official Receipt/Invoice for all services rendered',
        },
        {
          label: 'Legal Requirement',
          value: 'Mandatory under Philippine Tax Law',
        },
        {
          label: 'Non-Compliance Penalty',
          value: '2 to 4 years imprisonment for non-issuance',
        },
      ],
      description:
        'This official notice from the Bureau of Internal Revenue confirms that TravelEase.Co is legally required and authorized to issue official receipts and invoices for every service rendered or sale of goods. This ensures that all transactions are properly documented, tax-compliant, and traceable for consumer protection.',
    },
  ];

  return (
    <section data-component-id="src/app/legal/components/RegistrationDetails.tsx:135:4" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="135" data-component-end-line="198" data-component-file="RegistrationDetails.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%7D" className={`py-20 bg-white ${className}`}>
      <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:136:6" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="136" data-component-end-line="197" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:137:8" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="137" data-component-end-line="145" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
          <h2 data-component-id="src/app/legal/components/RegistrationDetails.tsx:138:10" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="138" data-component-end-line="140" data-component-file="RegistrationDetails.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20lg%3Atext-4xl%20font-pacifico%20text-brand-primary%20mb-4%22%2C%22textContent%22%3A%22Official%20Registration%20Documents%22%7D" className="text-3xl lg:text-4xl font-pacifico text-brand-primary mb-4">
            Official Registration Documents
          </h2>
          <p data-component-id="src/app/legal/components/RegistrationDetails.tsx:141:10" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="141" data-component-end-line="144" data-component-file="RegistrationDetails.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20text-brand-text-secondary%20max-w-3xl%20mx-auto%22%2C%22textContent%22%3A%22View%20our%20complete%20registration%20and%20compliance%20documentation%20with%20Philippine%20government%5Cn%20%20%20%20%20%20%20%20%20%20%20%20agencies%22%7D" className="text-lg text-brand-text-secondary max-w-3xl mx-auto">
            View our complete registration and compliance documentation with Philippine government
            agencies
          </p>
        </div>

        <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:147:8" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="147" data-component-end-line="196" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-20%22%7D" className="space-y-20">
          {registrationData.map((registration, index) => (
            <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:149:12" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="149" data-component-end-line="194" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-start ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:155:14" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="155" data-component-end-line="183" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`space-y-6 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:156:16" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="156" data-component-end-line="161" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
                  <h3 data-component-id="src/app/legal/components/RegistrationDetails.tsx:157:18" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="157" data-component-end-line="159" data-component-file="RegistrationDetails.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20font-bold%20text-brand-text-primary%20mb-2%22%7D" className="text-2xl font-bold text-brand-text-primary mb-2">
                    {registration.title}
                  </h3>
                  <p data-component-id="src/app/legal/components/RegistrationDetails.tsx:160:18" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="160" data-component-end-line="160" data-component-file="RegistrationDetails.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-brand-primary%20font-medium%22%7D" className="text-brand-primary font-medium">{registration.subtitle}</p>
                </div>

                <p data-component-id="src/app/legal/components/RegistrationDetails.tsx:163:16" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="163" data-component-end-line="165" data-component-file="RegistrationDetails.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-brand-text-secondary%20leading-relaxed%22%7D" className="text-brand-text-secondary leading-relaxed">
                  {registration.description}
                </p>

                <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:167:16" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="167" data-component-end-line="182" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-brand-surface%20rounded-brand-curve%20p-6%20space-y-4%22%7D" className="bg-brand-surface rounded-brand-curve p-6 space-y-4">
                  <h4 data-component-id="src/app/legal/components/RegistrationDetails.tsx:168:18" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="168" data-component-end-line="170" data-component-file="RegistrationDetails.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22font-semibold%20text-brand-text-primary%20mb-4%22%2C%22textContent%22%3A%22Registration%20Details%3A%22%7D" className="font-semibold text-brand-text-primary mb-4">
                    Registration Details:
                  </h4>
                  {registration.details.map((detail, detailIndex) => (
                    <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:172:20" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="172" data-component-end-line="180" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22border-b%20border-brand-accent%2F20%20pb-3%20last%3Aborder-0%22%7D"
                      key={detailIndex}
                      className="border-b border-brand-accent/20 pb-3 last:border-0"
                    >
                      <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:176:22" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="176" data-component-end-line="178" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-sm%20text-brand-text-secondary%20font-medium%20mb-1%22%7D" className="text-sm text-brand-text-secondary font-medium mb-1">
                        {detail.label}
                      </div>
                      <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:179:22" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="179" data-component-end-line="179" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-brand-text-primary%20font-semibold%22%7D" className="text-brand-text-primary font-semibold">{detail.value}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:185:14" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="185" data-component-end-line="193" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div data-component-id="src/app/legal/components/RegistrationDetails.tsx:186:16" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="186" data-component-end-line="192" data-component-file="RegistrationDetails.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22sticky%20top-24%20bg-white%20rounded-brand-curve%20overflow-hidden%20shadow-warm-lg%20border-4%20border-brand-accent%2F20%20hover%3Aborder-brand-primary%2F30%20gentle-transition%22%7D" className="sticky top-24 bg-white rounded-brand-curve overflow-hidden shadow-warm-lg border-4 border-brand-accent/20 hover:border-brand-primary/30 gentle-transition">
                  <AppImage data-component-id="src/app/legal/components/RegistrationDetails.tsx:187:18" data-component-path="src/app/legal/components/RegistrationDetails.tsx" data-component-line="187" data-component-end-line="191" data-component-file="RegistrationDetails.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-auto%20object-contain%22%7D"
                    src={registration.image}
                    alt={registration.alt}
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RegistrationDetails;
